import { useQuery } from '@tanstack/react-query';
import { dashboardAPI } from '../api/dashboard.api';
import { useMemo } from 'react';
import { calculateStats, processNotifications } from '../utils/dashboardHelpers';

export const useDashboard = () => {
  const { data, isLoading, error, refetch } = useQuery({
    queryKey: ['expert', 'dashboard', 'expertises'],
    queryFn: dashboardAPI.getDashboardExpertises,
    staleTime: 5 * 60 * 1000, // 5 minutes
    gcTime: 10 * 60 * 1000, // 10 minutes (renamed from cacheTime in React Query v5)
  });

  const { stats, notifications } = useMemo(() => {
    if (!data?.success || !data?.data?.expertises) {
      return {
        stats: {
          totalActive: 0,
          visitedThisWeek: 0,
          pendingReports: 0,
          urgentTasks: 0
        },
        notifications: {
          urgentDossiers: [],
          nextDay: null,
          pendingReports: []
        }
      };
    }

    const expertises = data.data.expertises;
    const stats = calculateStats(expertises);
    const notifications = processNotifications(expertises);

    return { stats, notifications };
  }, [data]);

  return {
    stats,
    notifications,
    isLoading,
    error,
    refetch
  };
};

export const useDashboardStats = () => {
  const { stats } = useDashboard();
  return stats;
};